export default "__VITE_ASSET__CgcVx2bP__"